
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comic/[comicId]",
      function () {
        return require("private-next-pages/comic/[comicId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comic/[comicId]"])
      });
    }
  